// UTC-0 Timezone
export const DEFAULT_TIMEZONE = "Europe/London";
